var React = require('react');

function CompressWide (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M500 160h-84V76a12 12 0 0 0-12-12h-40a12 12 0 0 0-12 12v124a23.94 23.94 0 0 0 24 24h124a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zM136 288H12a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h84v84a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12V312a23.94 23.94 0 0 0-24-24z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M500 288H376a23.94 23.94 0 0 0-24 24v124a12 12 0 0 0 12 12h40a12 12 0 0 0 12-12v-84h84a12 12 0 0 0 12-12v-40a12 12 0 0 0-12-12zM148 64h-40a12 12 0 0 0-12 12v84H12a12 12 0 0 0-12 12v40a12 12 0 0 0 12 12h124a23.94 23.94 0 0 0 24-24V76a12 12 0 0 0-12-12z","className":"fa-primary","key":2})]);
}

CompressWide.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = CompressWide;

CompressWide.default = CompressWide;
